import { useState } from "react";
import {
  HamburgerIcon,
  ItemLink,
  Menu,
  MenuHeaderMobile,
  MenuItem,
} from "./style";
import hamburger from "res/icons/hamburger.svg";

export const Navigation = ({ homeNavOnly }) => {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <>
      <MenuHeaderMobile>
        <HamburgerIcon
          menuOpen={navOpen}
          src={hamburger}
          onClick={() => setNavOpen(!navOpen)}
        />
      </MenuHeaderMobile>
      <Menu menuOpen={navOpen}>
        <ItemLink href="/">
          <MenuItem menuOpen={navOpen} onClick={() => setNavOpen(false)}>
            Home
          </MenuItem>
        </ItemLink>
        {!homeNavOnly && (
          <>
            <ItemLink href="#about-me">
              <MenuItem menuOpen={navOpen} onClick={() => setNavOpen(false)}>
                Über mich
              </MenuItem>
            </ItemLink>
            <ItemLink href="#services">
              <MenuItem menuOpen={navOpen} onClick={() => setNavOpen(false)}>
                Leistungen
              </MenuItem>
            </ItemLink>
            <ItemLink href="#gallery">
              <MenuItem menuOpen={navOpen} onClick={() => setNavOpen(false)}>
                Portfolio
              </MenuItem>
            </ItemLink>
            <ItemLink href="#feedback">
              <MenuItem menuOpen={navOpen} onClick={() => setNavOpen(false)}>
                Feedback
              </MenuItem>
            </ItemLink>
            <ItemLink href="#contact">
              <MenuItem menuOpen={navOpen} onClick={() => setNavOpen(false)}>
                Kontakt
              </MenuItem>
            </ItemLink>
          </>
        )}
      </Menu>
    </>
  );
};
